module.exports = __webpack_public_path__ + "/templates/components/sections/category/category-tripvariants[old].twig";